import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { IMAGES } from "@/data/site";
import { Reveal } from "./Reveal";

const PHOTOS = [
  { src: IMAGES.facade, alt: "Entrada do Espaço da Beleza", caption: "A nossa entrada" },
];

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="galeria" data-testid="gallery-section" className="py-16 sm:py-24 lg:py-32 bg-[#FFF0F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <p className="text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#C2185B]">
            Galeria
          </p>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900">
            Conheça o nosso <em className="text-[#C2185B]">espaço</em>
          </h2>
        </Reveal>

        <div className="mt-12 max-w-3xl">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src + i} delay={i * 0.05}>
              <button
                data-testid="gallery-item"
                onClick={() => setActive(p)}
                className="group relative w-full aspect-[4/3] rounded-3xl overflow-hidden border-[6px] border-white shadow-xl shadow-[#C2185B]/10 hover:shadow-2xl hover:shadow-[#C2185B]/25 transition-shadow duration-500 block"
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
                <span className="absolute bottom-5 left-5 text-white text-base font-medium opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-400">
                  {p.caption}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            data-testid="gallery-lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10"
          >
            <button
              data-testid="gallery-lightbox-close"
              className="absolute top-5 right-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/25 text-white flex items-center justify-center transition-colors"
              aria-label="Fechar"
            >
              <X size={20} />
            </button>
            <motion.figure
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.94, y: 10 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="max-h-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={active.src}
                alt={active.alt}
                className="max-h-[80vh] max-w-full rounded-2xl shadow-2xl object-contain"
              />
              <figcaption className="mt-4 text-center text-white/90 font-serif-display italic text-lg">
                {active.caption}
              </figcaption>
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
